import axios from "axios";
import { baseUrl } from "../util";

export const getAccountingYears = ({
  filters = null,
  sortBy = null,
  setAccountingYears,
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");

  var config = {
    method: "get",
    url: baseUrl + "/api/business/accounting-entries-economic",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      year: year,
      filter: filters,
      sort: sortBy,
    },
  };

  axios(config)
    .then(function (response) {
      const data = response.data.collection;
      setAccountingYears(
        data.map((item) => {
          item.label = item.year;
          return item;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};
